import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {styleMap} from 'lit/directives/style-map.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../store';

@customElement('dev-label')
export class DevLabel extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
			}
			.devLabel {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				margin-inline: auto;
				width: fit-content;

				background: rgba(255, 0 , 0, 0.3);
				color: white;
				pointer-events: none;
				padding: 5px 10px;
				font-family: Courier New, monospace;
				font-size: 15px;
				text-align: center;
				z-index: 1000;
			}

		`
	];

	constructor() {
		super();
		this.dev = !window.location.href.includes('selux.com');
		store.subscribe(() => this.requestUpdate());
	}

	render() {
		if (!this.dev) return null;
		return html`
			<div class="devLabel">
				<strong>Entwicklungsversion!</strong> Nicht für den Produktiveinsatz.
			</div>

		`;
	}
}
